import React from 'react';
import { Toaster } from 'react-hot-toast';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-white">
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            direction: 'rtl'
          }
        }}
      />
      <div className="max-w-4xl mx-auto p-4">
        <header className="text-center py-8">
          <h1 className="text-4xl font-bold text-indigo-900 mb-2">
            محلل SWOT للمشاريع السعودية
          </h1>
          <p className="text-indigo-600">
            تحليل ذكي لمشروعك باستخدام الذكاء الاصطناعي
          </p>
        </header>
        {children}
      </div>
    </div>
  );
};